import { rxsHtmlAttrCapture } from './regex';

export function removeAttrs(attrsHaystack: string, attrToRemove: string): string {
	const rxAttr = new RegExp(rxsHtmlAttrCapture, 'gi');

	const attrToRemove2 = attrToRemove.toLowerCase();

	const attrsHaystackFiltered = attrsHaystack.replace(rxAttr, (match: string, attr: string) => {
		const attr2 = attr.toLowerCase();
		if (attr2 === attrToRemove2) {
			return '';
		} else {
			return match;
		}
	});

	return attrsHaystackFiltered;
}
